import { Button, useToast } from "@chakra-ui/react";
import { StripeBillingPortalAction } from "@syla/shared/types/requests/CreateStripeBillingPortalRequest";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { errorToastOptions } from "../../../components/molecules/errorToastOptions";
import { captureRequestError } from "../../../helper/captureRequestError";
import { getFullPageUrl } from "../../../helper/getFullPageUrl";
import { redirectTo } from "../../../helper/RedirectTo";
import { useMutationCreateStripeBillingPortalSession } from "../../../store/useMutationCreateStripeBillingPortalSession";
import { useStripePortalRedirectStore } from "../../../store/useStripePortalRedirectStore";

export const ResumePlanButton = ({
  accountId,
  label,
}: {
  accountId: string;
  label: string;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const toast = useToast(errorToastOptions);
  const { mutateAsync } = useMutationCreateStripeBillingPortalSession();

  const { isRedirecting, startRedirect, endRedirect } =
    useStripePortalRedirectStore();

  useStripePortalRedirectStore;
  const handleClick = async () => {
    if (!startRedirect()) {
      return;
    }

    setIsLoading(true);
    try {
      const response = await mutateAsync({
        accountId,
        action: StripeBillingPortalAction.MainPortal,
        returnUrl: getFullPageUrl(location),
      });

      redirectTo(response.portalUrl);
    } catch (error) {
      captureRequestError(error);
      toast({
        title: "Failed to open billing portal",
        description: "An unexpected error occurred. Please try again later.",
      });
      endRedirect(); // only reset on error
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      colorScheme="gray"
      backgroundColor="white"
      size="sm"
      isDisabled={isRedirecting}
      isLoading={isLoading}
      onClick={handleClick}
    >
      {label}
    </Button>
  );
};
